var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronWhiteRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81295 0.146447C4.00821 -0.0488155 4.3248 -0.0488155 4.52006 0.146447L11.6665 7.29286C11.7594 7.38567 11.8332 7.4959 11.8835 7.61724C11.9338 7.73858 11.9597 7.86865 11.9597 8C11.9597 8.13135 11.9338 8.26142 11.8835 8.38276C11.8332 8.5041 11.7594 8.61433 11.6665 8.70714L4.52006 15.8536C4.3248 16.0488 4.00821 16.0488 3.81295 15.8536C3.61769 15.6583 3.61769 15.3417 3.81295 15.1464L10.9594 8L3.81295 0.853553C3.61769 0.658291 3.61769 0.341709 3.81295 0.146447Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronWhiteRight);
export default __webpack_public_path__ + "static/media/chevron-white-right.f55ec7006fefe2f3a76762558b548c52.svg";
export { ForwardRef as ReactComponent };